module.exports = __webpack_public_path__ + "img/instructions_03.0a358df1.svg";